import { useEffect, useState } from "react";
import axios from "../../axios";
// import { Link } from "react-router-dom";
import "./HomePage.css"; // kita buat style khusus
// import formatCurrency from "../../utils/formatCurrency";
// import { STORAGE_URL } from "../../constants";

export default function HomePage() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await axios.get("/about");
                setContent(res.data?.content || "");
            } catch (err) {
                console.error("Gagal memuat data", err);
            }
        };
        fetch();

        
    }, []);


    return (
        <div className="mt-24">
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
}
